export default __webpack_public_path__ + "static/media/daily-web-app.0f4cc483.png";